var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitbook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 8H8C7.4 8 7 8.4 7 9V27C7 27.6 7.4 28 8 28H28C28.6 28 29 27.6 29 27V9C29 8.4 28.6 8 28 8ZM27 26H9V10H27V26Z",
    fill: "#8ABE84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14H24V16H12V14ZM12 18H20V20H12V18ZM12 22H22V24H12V22Z",
    fill: "#8ABE84"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitbook);
export default __webpack_public_path__ + "static/media/gitbook.e136517add26332f3a7107b6295c1bc7.svg";
export { ForwardRef as ReactComponent };